/* Waifu Bean — global.js. Vanilla, no dependencies. */
(function () {
  'use strict';

  var focusReturn = null;

  /* Generic drawer open/close ------------------------------------------- */
  function openDrawer(drawer) {
    if (!drawer) return;
    focusReturn = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (focusReturn && focusReturn.focus) focusReturn.focus();
  }
  function closeAllDrawers() {
    document.querySelectorAll('.drawer.is-open').forEach(closeDrawer);
    var menu = document.querySelector('[data-menu-drawer].is-open');
    if (menu) menu.classList.remove('is-open');
    var overlay = document.querySelector('[data-menu-overlay].is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* Mobile menu drawer --------------------------------------------------- */
  function initMenuDrawer() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var drawer = document.querySelector('[data-menu-drawer]');
    var overlay = document.querySelector('[data-menu-overlay]');
    var closeBtn = document.querySelector('[data-menu-close]');
    if (!toggle || !drawer) return;

    function open() {
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var firstLink = drawer.querySelector('a, button');
      if (firstLink) firstLink.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      toggle.focus();
    }
    toggle.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);
  }

  /* Tap the sticky header to jump back to top ----------------------------
     Only wires up when the header is actually sticky -- if a merchant turns
     that setting off, the header scrolls out of view like normal and there's
     nothing to tap. Clicks on the header's own links/buttons (logo, menu,
     search, account, cart) are left alone; only clicks that land on the
     header's background/whitespace trigger the scroll. */
  function initHeaderTapToTop() {
    var header = document.querySelector('.header--sticky');
    if (!header) return;
    header.addEventListener('click', function (e) {
      if (e.target.closest('a, button')) return;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* Rotating announcements ---------------------------------------------- */
  function initAnnouncements() {
    document.querySelectorAll('[data-announcement-rotator]').forEach(function (rotator) {
      var items = rotator.querySelectorAll('.announcement-bar__item');
      if (items.length < 2) return;
      var i = 0;
      items.forEach(function (item, idx) { item.hidden = idx !== 0; });
      setInterval(function () {
        items[i].hidden = true;
        i = (i + 1) % items.length;
        items[i].hidden = false;
      }, 5000);
    });
  }

  /* Countdown timer ------------------------------------------------------ */
  function initCountdowns() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var target = new Date(el.getAttribute('data-countdown')).getTime();
      if (isNaN(target)) return;
      var out = {
        d: el.querySelector('[data-cd-days]'), h: el.querySelector('[data-cd-hours]'),
        m: el.querySelector('[data-cd-mins]'), s: el.querySelector('[data-cd-secs]')
      };
      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) { el.classList.add('is-complete'); return; }
        if (out.d) out.d.textContent = Math.floor(diff / 86400000);
        if (out.h) out.h.textContent = ('0' + Math.floor((diff % 86400000) / 3600000)).slice(-2);
        if (out.m) out.m.textContent = ('0' + Math.floor((diff % 3600000) / 60000)).slice(-2);
        if (out.s) out.s.textContent = ('0' + Math.floor((diff % 60000) / 1000)).slice(-2);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------------------------------------------------------------------
     Cart drawer + Section Rendering API
     --------------------------------------------------------------------- */
  var CartDrawer = {
    el: null,
    init: function () {
      this.el = document.querySelector('[data-cart-drawer]');

      // Open on cart icon click (refresh contents first)
      document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          if (!CartDrawer.el) return; // no JS drawer -> follow href
          e.preventDefault();
          CartDrawer.refreshAndOpen();
        });
      });

      // Quantity change + remove (delegated)
      if (this.el) {
        this.el.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-qty-change]');
          if (!btn) return;
          e.preventDefault();
          CartDrawer.changeQuantity(btn.getAttribute('data-qty-change'), btn.getAttribute('data-qty'));
        });
      }
    },

    updateCounts: function (count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
      var label = CartDrawer.el && CartDrawer.el.querySelector('.drawer__count');
      if (label) label.textContent = '(' + count + ')';
    },

    // Replace drawer body/footer from a rendered section HTML string
    render: function (sectionHTML) {
      if (!this.el || !sectionHTML) return;
      var parsed = new DOMParser().parseFromString(sectionHTML, 'text/html');
      var newContents = parsed.querySelector('.js-cart-contents');
      var newFooter = parsed.querySelector('.js-cart-footer');
      var curContents = this.el.querySelector('.js-cart-contents');
      var curFooterWrap = this.el.querySelector('.drawer__footer');

      if (newContents && curContents) curContents.innerHTML = newContents.innerHTML;

      // Footer may appear/disappear (empty <-> filled)
      var panel = this.el.querySelector('.drawer__panel');
      if (curFooterWrap) curFooterWrap.remove();
      if (newFooter) panel.appendChild(newFooter);
    },

    fetchSection: function () {
      return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?sections=cart-drawer' : '/?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (data) { return data['cart-drawer']; });
    },

    refreshAndOpen: function () {
      this.fetchSection().then(function (html) {
        CartDrawer.render(html);
        openDrawer(CartDrawer.el);
        var closeBtn = CartDrawer.el.querySelector('[data-drawer-close]');
        if (closeBtn && closeBtn.focus) closeBtn.focus();
      }).catch(function () { openDrawer(CartDrawer.el); });
    },

    // One add path for every form on the site. Posting the form's own
    // FormData rather than a hand-built {id, quantity} means whatever the
    // form carries goes with it -- the quantity field on a product page,
    // selling_plan if a subscription is ever offered, line item properties --
    // instead of being silently dropped by a payload that only knows two keys.
    addFromForm: function (form, button) {
      if (form.dataset.adding === '1') return;   // guards double-click / Enter-twice
      form.dataset.adding = '1';

      var original = button ? button.textContent : '';
      if (button) { button.textContent = 'Adding…'; button.disabled = true; }
      CartDrawer.clearError(form);

      var body = new FormData(form);
      body.append('sections', 'cart-drawer');
      // A submit button's own name=value is only included when it is the
      // element that submitted; append() would send add= on every request.
      body.delete('add');

      // No Content-Type header on purpose: the browser has to set the
      // multipart boundary itself.
      return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok || res.data.status) {
            throw new Error(res.data.description || res.data.message || 'Could not add to cart');
          }
          if (res.data.sections && res.data.sections['cart-drawer']) {
            CartDrawer.render(res.data.sections['cart-drawer']);
          }
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          CartDrawer.updateCounts(cart.item_count);
          if (button) {
            button.textContent = 'Added ✓';
            setTimeout(function () { button.textContent = original; button.disabled = false; }, 1400);
          }
          openDrawer(CartDrawer.el);
        })
        .catch(function (err) {
          if (button) { button.textContent = original; button.disabled = false; }
          // Shown, not just logged -- a silent failure reads as a dead button.
          CartDrawer.showError(form, err.message);
        })
        .then(function () { form.dataset.adding = ''; });
    },

    showError: function (form, message) {
      var p = form.querySelector('[data-cart-error]');
      if (!p) {
        p = document.createElement('p');
        p.className = 'form-status form-status--error';
        p.setAttribute('data-cart-error', '');
        p.setAttribute('role', 'alert');
        form.appendChild(p);
      }
      p.textContent = message;
    },

    clearError: function (form) {
      var p = form.querySelector('[data-cart-error]');
      if (p) p.remove();
    },

    changeQuantity: function (key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: parseInt(quantity, 10), sections: 'cart-drawer' })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart.sections && cart.sections['cart-drawer']) CartDrawer.render(cart.sections['cart-drawer']);
          CartDrawer.updateCounts(cart.item_count);
        });
    }
  };

  /* Add to cart ----------------------------------------------------------
     Both the collection-card quick-add and the product page's own form go
     through the drawer. The product form used to have no handler at all, so
     it posted natively and Shopify answered with a redirect to /cart --
     which is why adding an item threw you off the page you were browsing.

     Every handler bails out if the drawer is missing, and none of them stop
     the default unless the fetch is actually taking over, so with JavaScript
     off or broken these stay ordinary forms that post to /cart. The cart page
     itself is untouched and still reachable from the header and the drawer. */
  function initCartForms() {
    var forms = document.querySelectorAll('[data-quick-add], #ProductForm');
    Array.prototype.forEach.call(forms, function (form) {
      if (form.dataset.cartBound === '1') return;   // survives re-render
      form.dataset.cartBound = '1';
      form.addEventListener('submit', function (e) {
        if (!CartDrawer.el) return;                 // no drawer -> normal post
        e.preventDefault();
        var btn = form.querySelector('[data-add-button]') || form.querySelector('[type="submit"]');
        CartDrawer.addFromForm(form, btn);
      });
    });
  }

  /* ---------------------------------------------------------------------
     Predictive search drawer
     --------------------------------------------------------------------- */
  var Search = {
    el: null,
    init: function () {
      this.el = document.querySelector('[data-search-drawer]');
      if (!this.el) return;
      var input = this.el.querySelector('[data-predictive-input]');
      var results = this.el.querySelector('[data-predictive-results]');
      var empty = this.el.querySelector('[data-predictive-empty]');

      document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          openDrawer(Search.el);
          setTimeout(function () { if (input) input.focus(); }, 60);
        });
      });

      var timer;
      if (input) {
        input.addEventListener('input', function () {
          clearTimeout(timer);
          var term = input.value.trim();
          if (term.length < 2) { results.innerHTML = ''; if (empty) empty.hidden = false; return; }
          timer = setTimeout(function () { Search.query(term, results, empty); }, 250);
        });
      }
    },

    query: function (term, results, empty) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(term) +
        '&resources[type]=product,collection,page&resources[limit]=6' +
        '&resources[options][unavailable_products]=last';
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var res = (data.resources && data.resources.results) || {};
          Search.render(res, term, results, empty);
        })
        .catch(function () { results.innerHTML = '<p class="search-drawer__error">Search is unavailable right now.</p>'; });
    },

    render: function (res, term, results, empty) {
      var products = res.products || [];
      var collections = res.collections || [];
      var pages = res.pages || [];
      if (!products.length && !collections.length && !pages.length) {
        results.innerHTML = '<p class="search-drawer__noresults">No matches for “' + Search.escape(term) + '”.</p>';
        if (empty) empty.hidden = true;
        return;
      }
      if (empty) empty.hidden = true;
      var html = '';

      if (products.length) {
        html += '<div class="search-drawer__group"><h3 class="search-drawer__group-title">Products</h3><ul class="search-drawer__list">';
        products.forEach(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
          html += '<li><a class="search-result" href="' + p.url + '">' +
            (img ? '<img class="search-result__img" src="' + img + '" alt="" width="56" height="56" loading="lazy">' : '<span class="search-result__img"></span>') +
            '<span class="search-result__info"><span class="search-result__title">' + Search.escape(p.title) + '</span>' +
            (p.price ? '<span class="search-result__price">' + p.price + '</span>' : '') +
            '</span></a></li>';
        });
        html += '</ul></div>';
      }
      if (collections.length) {
        html += '<div class="search-drawer__group"><h3 class="search-drawer__group-title">Collections</h3><ul class="search-drawer__list">';
        collections.forEach(function (c) { html += '<li><a class="search-result search-result--text" href="' + c.url + '">' + Search.escape(c.title) + '</a></li>'; });
        html += '</ul></div>';
      }
      if (pages.length) {
        html += '<div class="search-drawer__group"><h3 class="search-drawer__group-title">Pages</h3><ul class="search-drawer__list">';
        pages.forEach(function (pg) { html += '<li><a class="search-result search-result--text" href="' + pg.url + '">' + Search.escape(pg.title) + '</a></li>'; });
        html += '</ul></div>';
      }
      html += '<a class="search-drawer__all link-arrow" href="/search?q=' + encodeURIComponent(term) + '">View all results →</a>';
      results.innerHTML = html;
    },

    escape: function (s) {
      var d = document.createElement('div'); d.textContent = s; return d.innerHTML;
    }
  };

  /* Global drawer close wiring ------------------------------------------ */
  function initDrawerClose() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-close]')) {
        var drawer = e.target.closest('.drawer');
        if (drawer) closeDrawer(drawer);
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllDrawers();
    });
  }

  /* Newsletter feedback -------------------------------------------------- */
  function initNewsletterFocus() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('customer_posted') === 'true') {
      var status = document.querySelector('[data-newsletter-success]');
      if (status && status.focus) status.focus();
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMenuDrawer();
    initHeaderTapToTop();
    initAnnouncements();
    initCountdowns();
    CartDrawer.init();
    Search.init();
    initCartForms();
    initDrawerClose();
    initNewsletterFocus();
  });
})();
